import { IPageProps } from '@ucheba/utils/helpers/components/types'
import {
  EInstitutionMediaType,
  EInstitutionType,
  IImage,
  IInstitutionMediaListItem,
  IInstitutionOfficialRepresentative,
} from '@ucheba/store/institutions/item/types'

import { ILightGallerySettings } from '@ucheba/ui/components/LightGallery/types'
import { ReactElement, ReactNode } from 'react'
import { EModButtonSize } from '@ucheba/ui/components/Button/types'

export interface IOfficialRepresentativeProps extends IInstitutionOfficialRepresentative {
  type: EInstitutionType
  handleOpenDialog: () => void
  size?: keyof typeof EModButtonSize
}

export interface IUzPageProps extends IPageProps {}

export interface IPhotosItemProps {
  slideWidth: string
  thumb: IImage
  gridArea: string
  mediaType: EInstitutionMediaType
}

export interface IMediaListItem {
  id: number
  fileUrl: string
  thumbnailUrl: string | null
  mediaType: {
    name: string
    value: EInstitutionMediaType
  }
  isOfficialPromo: boolean
  description: null | string
}

export interface IGalleryItem {
  src: string
  thumb: IImage
  subHtml: string
  alt: string
  width: string
  height: string
  children: React.ReactNode
}

export interface IGalleryComponentProps {
  mediaList: IInstitutionMediaListItem[]
}

export interface ILightGalleryProps {
  settings?: ILightGallerySettings
  gridArea?: string
  gridTemplateAreas?: string
  itemsCount?: number
  slideWidth?: number
}

export enum UzSectionsEnum {
  programs = 'programs',
  promotions = 'promotions',
  opinions = 'opinions',
  events = 'events',
  news = 'news',
  teachers = 'teachers',
  articles = 'articles',
  comments = 'comments',
  olympiads = 'olympiads',
  units = 'units',
  partners = 'partners',
  contacts = 'contacts',
  career = 'career',
}

export interface IInstitutionLayout {
  showButtons?: boolean
  showRepresentative?: boolean
  showEducationalInstitutionAddedNotification?: boolean
  children: ReactElement | ReactNode
  showBlockWithButtons?: boolean
  questionsListLimit?: number
  questionsListOffset?: number
  onQuestionAfterSubmit?: () => void
}

export interface IContent {
  children: ReactElement | ReactNode
}
